module.exports = __webpack_public_path__ + "img/daba486.jpg";